var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Stats = function (_a) {
    var items = _a.items;
    return (_jsx("div", { children: _jsx("dl", __assign({ className: "mt-5 grid grid-cols-1 divide-y divide-gray-200 overflow-hidden rounded-lg bg-white border md:grid-cols-3 md:divide-y-0 md:divide-x" }, { children: items.map(function (item) { return (_jsxs("div", __assign({ className: "px-4 py-5 sm:p-6" }, { children: [_jsx("dt", __assign({ className: "truncate text-sm font-medium text-gray-500" }, { children: item.name })), _jsx("dd", __assign({ className: "mt-1 font-semibold text-xl tracking-tight text-gray-900" }, { children: item.stat }))] }), item.name)); }) })) }));
};
export default Stats;
